import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DataBaseService {
   urlDataBase:any = "https://j2t5avx5x1.execute-api.sa-east-1.amazonaws.com/v1/api";
   API_URL_SAUDADE:any = this.urlDataBase+'/saudade';
   API_URL_BAILE:any = this.urlDataBase+'/baile';
   API_URL_CIDADES:any = this.urlDataBase+'/cidades';
   API_URL_COLACAO:any = this.urlDataBase+'/colacao';
   API_URL_CURSOS:any = this.urlDataBase+'/cursos';
   API_URL_TODOS_CURSOS:any = this.urlDataBase+'/todoscursos';
   API_URL_EVENTOS:any = this.urlDataBase+'/eventos';
   API_URL_INSTITUICOES:any = this.urlDataBase+'/instituicoes';
   API_URL_JANTAR:any = this.urlDataBase+'/jantar';
   API_URL_MISSA:any = this.urlDataBase+'/missa';
   API_URL_TURMAS:any = this.urlDataBase+'/turmas';
   API_URL_USUARIOS:any = this.urlDataBase+'/usuarios';
   API_URL_GALERIAS:any = this.urlDataBase+'/galerias';
   API_URL_IMAGENS:any = this.urlDataBase+'/imagens';
   API_URL_SAUDADE_COL:any = this.urlDataBase+'/saudadecol';
   API_URL_MISSA_COL:any = this.urlDataBase+'/missacol';
   API_URL_JANTAR_COL:any = this.urlDataBase+'/jantarcol';
   API_URL_COLACAO_COL:any = this.urlDataBase+'/colacaocol';
   API_URL_BAILE_COL:any = this.urlDataBase+'/bailecol';
   API_URL_RELATORIOS:any = this.urlDataBase+'/relatorios';
   API_URL_CONFIGS:any = this.urlDataBase+'/configs';
   API_URL_ORCAMENTOS:any = this.urlDataBase+'/orcamentos';
   API_URL_DOCUMENTOS:any = this.urlDataBase+'/documentos';
   API_URL_AGENDA:any = this.urlDataBase+'/agenda';
   API_URL_CONTRATOS:any = this.urlDataBase+'/contratos';
   API_URL_EMPRESAS:any = this.urlDataBase+'/empresas';
   API_URL_FOTOS:any = this.urlDataBase+'/fotos';
   API_URL_LOGS:any = this.urlDataBase+'/logs';
   API_URL_MINHA_FORMATURA:any = this.urlDataBase+'/minhaformatura';
   API_URL_PERSONALIZADOS_BAILE:any = this.urlDataBase+'/personalizadosBaile';
   API_URL_PERSONALIZADOS_BAILE_COLEGIO:any = this.urlDataBase+'/personalizadosBaileColegio';
   API_URL_FORMATURA_INFANTIL:any = this.urlDataBase+'/formaturainf';
   API_URL_PROD_FOTO_INFANTIL:any = this.urlDataBase+'/prodfotoinf';
   API_URL_PRE_EVENTOS_INFANTIL:any = this.urlDataBase+'/preeventosinf';

   urlSite:any = 'https://app.trendsformaturas.com.br';
   tema:any = "#795896"
   constructor(public http:HttpClient){}

   getOrcamentoByTurmaId(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"turmaId":"'+key+'"}&sort={"data":-1, "hora":-1}')
   }

   getDocumentosByTurmaId(key:any){
      return this.http.get(this.API_URL_DOCUMENTOS+'?filtro={"turmaId":"'+key+'"}')
   }

   getRelatoriosByTurmaId(key:any){
      return this.http.get(this.API_URL_RELATORIOS+'?filtro={"idTurma":"'+key+'"}&sort={"data":-1, "hora":-1}')
   }

   getContratosByTurmaId(key:any){
      return this.http.get(this.API_URL_CONTRATOS+'?filtro={"turmaId":"'+key+'"}')
   }

   getCursosByInstituicao(key:any){
      return this.http.get(this.API_URL_CURSOS+'?filtro={"instituicao":"'+key+'"}')
   }

   getCursosByNomeInstituicao(curso:any,faculdade:any){
      return this.http.get(this.API_URL_CURSOS+'?filtro={"nome":"'+curso+'", "instituicao":"'+faculdade+'"}')
   }

   getCursosByInstituicaoCidade(instituicao:any,cidade:any){
      return this.http.get(this.API_URL_CURSOS+'?filtro={"instituicao":"'+instituicao+'", "cidade":"'+cidade+'"}&sort={"nome":1}')
   }

   getCursosByInstituicaoCidadeNome(instituicao:any,cidade:any,nome:any){
      return this.http.get(this.API_URL_CURSOS+'?filtro={"instituicao":"'+instituicao+'", "cidade":"'+cidade+'","nome":"'+nome+'"}&sort={"nome":1}')
   }
   
   getInstituicoesByCidade(key:any){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"tipo":"UNIVERSIDADE","cidade":"'+key+'"}&sort={"nome":1}')
   } 

   getInstituicoesColegioByCidade(key:any){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"cidade":"'+key+'","tipo":"COLEGIO"}&sort={"nome":1}')
   }

   getInstituicoesEscolaColegioByCidade(key:any){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"cidade":"'+key+'","$or":[{"tipo":"COLEGIO"},{"tipo":"ESCOLA"}]}&sort={"nome":1}')
   }

   getInstituicoesEscolaByCidade(key:any){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"cidade":"'+key+'","tipo":"ESCOLA"}&sort={"nome":1}')
   }

   getInstituicoesInfantilByCidade(key:any){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"cidade":"'+key+'","tipo":"INFANTIL"}&sort={"nome":1}')
   }

   getProposta(){
      return this.http.get(this.API_URL_CONFIGS+'?filtro={"nome":"nProposta"}')
   }

   getSms(){
      return this.http.get(this.API_URL_CONFIGS+'?filtro={"nome":"sms"}')
   }

   patchProposta(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_CONFIGS+'/'+id,body)
   }

   patchCursos(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_CONFIGS+'/'+id,body)
   }

   patchAssessorias(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_CONFIGS+'/'+id,body)
   }

   //VER
   patchPersonalizadosBaile(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_PERSONALIZADOS_BAILE+'/'+id,body)
   }
   //VER
   patchPersonalizadosBaileColegio(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_PERSONALIZADOS_BAILE_COLEGIO+'/'+id,body)
   }
   
   getAssessoria(){
      return this.http.get(this.API_URL_CONFIGS+'?filtro={"nome":"assessoria"}')
   }

   getAssessorias(){
      return this.http.get(this.API_URL_CONFIGS+'?filtro={"nome":"assessorias}')
   }

   getCursosConfig(){
      return this.http.get(this.API_URL_CONFIGS+'?filtro={"nome":"cursos"}')
   }

   getConfigs(){
      return this.http.get(this.API_URL_CONFIGS);
   }

   patchAssessoria(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_CONFIGS+'/'+id,body)
   }

   getEventos(){
      return this.http.get(this.API_URL_EVENTOS);
   }

   getLogs(){
      return this.http.get(this.API_URL_LOGS);
   }

   getLogsFilter(dtInicio:any,dtFim:any,descricao:any){
      return this.http.get(this.API_URL_LOGS+'?filtro={"data":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"descricao":{"$regex":"'+descricao+'","$options":"i"}}');
   }

   getFotos(){
      return this.http.get(this.API_URL_FOTOS);
   }

   getFotosInfantil(){
      return this.http.get(this.API_URL_FOTOS+'?filtro={"galeria":"INFANTIL"}');
   }

   getFotosById(id:any){
      return this.http.get(this.API_URL_FOTOS+'/'+id);
   }

   getEventosById(id:any){
      return this.http.get(this.API_URL_EVENTOS+'/'+id);
   }

   getEventosByCidade(key:any){
      return this.http.get(this.API_URL_EVENTOS+'?filtro={"cidade":"'+key+'"}');
   }

   patchEventos(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_EVENTOS+'/'+id,body)
   }

   patchFotos(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_FOTOS+'/'+id,body)
   }

   postFotos(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_FOTOS,body);
   }

   postLogs(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_LOGS,body);
   }

   postEventos(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_EVENTOS,body);
   }

   novaEmpresa(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_EMPRESAS,body);
   }

   postOrcamento(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_ORCAMENTOS,body);
   }

   delEventos(id:any){
      return this.http.delete(this.API_URL_EVENTOS+'/'+id);
     }

   delItemFotos(id:any){
   return this.http.delete(this.API_URL_FOTOS+'/'+id);
   }

   getBaile(){
      return this.http.get(this.API_URL_BAILE+'?sort={"titulo":1}');
   }

   getBaileById(id:any){
      return this.http.get(this.API_URL_BAILE+'/'+id);
   }

   patchBaile(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_BAILE+'/'+id,body)
   }

   postBaile(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_BAILE,body);
   }

   delBaile(id:any){
      return this.http.delete(this.API_URL_BAILE+'/'+id);
     }

   getJantar(){
      return this.http.get(this.API_URL_JANTAR+'?sort={"titulo":1}');
   }

   getJantarById(id:any){
      return this.http.get(this.API_URL_JANTAR+'/'+id);
   }

   patchJantar(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_JANTAR+'/'+id,body)
   }

   postJantar(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_JANTAR,body);
   }

   delJantar(id:any){
      return this.http.delete(this.API_URL_JANTAR+'/'+id);
     }

   getColacao(){
      return this.http.get(this.API_URL_COLACAO+'?sort={"titulo":1}');
   }

   getColacaoById(id:any){
      return this.http.get(this.API_URL_COLACAO+'/'+id);
   }

   patchColacao(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_COLACAO+'/'+id,body)
   }

   postColacao(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_COLACAO,body);
   }

   delColacao(id:any){
      return this.http.delete(this.API_URL_COLACAO+'/'+id);
     }

   getMissa(){
      return this.http.get(this.API_URL_MISSA+'?sort={"titulo":1}');
   }

   getMissaById(id:any){
      return this.http.get(this.API_URL_MISSA+'/'+id);
   }

   patchMissa(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_MISSA+'/'+id,body)
   }

   postMissa(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_MISSA,body);
   }

   delMissa(id:any){
      return this.http.delete(this.API_URL_MISSA+'/'+id);
     }

   getSaudade(){
      return this.http.get(this.API_URL_SAUDADE+'?sort={"titulo":1}');
   }

   getSaudadeById(id:any){
      return this.http.get(this.API_URL_SAUDADE+'/'+id);
   }

   patchSaudade(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_SAUDADE+'/'+id,body)
   }

   postSaudade(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_SAUDADE,body);
   }

   delSaudade(id:any){
      return this.http.delete(this.API_URL_SAUDADE+'/'+id);
     }

   postGaleria(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_GALERIAS,body)
    }

    patchGaleria(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_GALERIAS+'/'+id,body)
    }

   deleteImagemGaleria(id:any){
      return this.http.delete(this.API_URL_IMAGENS+'/'+id);
     }

   removeDoc(fullUrl:any){
      let url = this.urlSite+'/deleteDoc.php?path='+fullUrl;
      return this.http.post(url,{});
    }

    removeUpload(fullUrl:any){
      let url = this.urlSite+'/deleteImagem.php?path='+fullUrl;
      return this.http.post(url,{});
    }

    removeDocTurma(fullUrl:any){
      let url = this.urlSite+'/deleteDocTurma.php?path='+fullUrl;
      return this.http.post(url,{});
    }

   getImagensByUrl(nomeGaleria:any){
      return this.http.get(this.API_URL_IMAGENS+'?filtro={"url":{"$regex":"'+nomeGaleria+'"}}')
   }

   postImagem(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_IMAGENS,body)
   }

   postDocumentos(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_DOCUMENTOS,body)
   }

   deleteGaleria(id:any){
      return this.http.delete(this.API_URL_GALERIAS+'/'+id);
   }

   getGaleriaByName(galeria:any){
      return this.http.get(this.API_URL_IMAGENS+'?filtro={"galeria":"'+galeria+'"}')
   }

   enviarImagemGaleria(galeria:any,imagedata:any,random:any){
      let url = this.urlSite+'/uploadDoc.php?galeria='+galeria+'&random='+random;
      return this.http.post(url, imagedata);
   }

   getGalerias(){
      return this.http.get(this.API_URL_GALERIAS+'?sort={"galeria":1}')
   }

   getGaleriaById(id:any){
      return this.http.get(this.API_URL_GALERIAS+'/'+id);
    }

   getOrcamentoById(id:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'/'+id);
    }

    getTodasTurmas(tipo:any,formado:boolean){
     let formados = !formado ? '"situacao":{"$not":{"$regex":"FORMADO","$options":"i"}},' : '"situacao":"FORMADO",';
      return this.http.get(this.API_URL_TURMAS+'?filtro={'+formados+'"tipo":"'+tipo+'"}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getEmpresas(){
      return this.http.get(this.API_URL_EMPRESAS+'?sort={"nome":1}');
    }    

    getTurmasByData(dataInicio:any,dataFim:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"dataFim":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmasByCidade(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"cidade":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }
    
    getTurmasByGraduacao(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"graduacao":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmasByInstituicao(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"instituicao":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmasByCurso(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"curso":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmasBySituacao(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"situacao":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmasByConsultor(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"consultor":{"$regex":"'+key+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }  

    getTurmasGeral(dataInicio:any,dataFim:any,curso:any,instituicao:any,graduacao:any,cidade:any,situacao:any,consultor:any,tipoturmas:any){
      let sit:any = "";
      let tipo:any = tipoturmas ? ',"tipo":"'+tipoturmas+'"' : '';
      if(dataInicio == ""){dataInicio = "2000-01-01"}
       if(dataFim == ""){dataFim = "5000-01-01"}
       if(situacao == ""){sit = '"situacao":{"$ne":"FORMADO"},'}else{sit = '"situacao":{"$regex":"'+situacao+'","$options":"i"},'}

      return this.http.get(this.API_URL_TURMAS+'?filtro={'+sit+'"dataInicio":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"dataFim":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"curso":{"$regex":"'+curso+'","$options":"i"},"instituicao":{"$regex":"'+instituicao+'","$options":"i"},"graduacao":{"$regex":"'+graduacao+'","$options":"i"},"cidade":{"$regex":"'+cidade+'","$options":"i"},"consultor":{"$regex":"'+consultor+'","$options":"i"}}&sort={"cidade":1,"instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }  

    getTurmasGeralFormados(dataInicio:any,dataFim:any,curso:any,instituicao:any,graduacao:any,cidade:any,consultor:any){
      if(dataInicio == ""){
         dataInicio = "2000-01-01"
      }
      if(dataFim == ""){
         dataFim = "5000-01-01"
      }
     return this.http.get(this.API_URL_TURMAS+'?filtro={"situacao":"FORMADO","dataInicio":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"dataFim":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"curso":{"$regex":"'+curso+'","$options":"i"},"instituicao":{"$regex":"'+instituicao+'","$options":"i","$not":{"$regex":"COLÉGIO","$options":"i"}},"graduacao":{"$regex":"'+graduacao+'","$options":"i"},"cidade":{"$regex":"'+cidade+'","$options":"i"},"consultor":{"$regex":"'+consultor+'","$options":"i"}}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
   }  

    getTurmasGeralColegio(dataInicio:any,dataFim:any,curso:any,instituicao:any,cidade:any,situacao:any,consultor:any){
      if(dataInicio == ""){
         dataInicio = "2000-01-01"
      }
      if(dataFim == ""){
         dataFim = "5000-01-01"
      }
     return this.http.get(this.API_URL_TURMAS+'?filtro={"dataInicio":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"dataFim":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"curso":{"$regex":"'+curso+'","$options":"i"},"instituicao":{"$regex":"COLÉGIO'+instituicao+'","$options":"i"},"cidade":{"$regex":"'+cidade+'","$options":"i"},"situacao":{"$regex":"'+situacao+'","$options":"i"},"consultor":{"$regex":"'+consultor+'","$options":"i"}}');
   }  

    getTurmasByCursoOrcamento(curso:any,instituicao:any,cidade:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"curso":"'+curso+'", "instituicao":"'+instituicao+'", "cidade":"'+cidade+'","situacao":{"$not":{"$regex":"FECHADO","$options":"i"}}}');
    }

   getTurmaById(id:any){
      return this.http.get(this.API_URL_TURMAS+'/'+id);
    }

    getTurmaBySituacao(key:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"situacao":"'+key+'"}');
    }

    getTurmaInicio(){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"situacao":{"$not":{"$regex":"FORMADO","$options":"i"}},"tipo":"UNIVERSIDADE","$or":[{"situacao":"ATENDIMENTO URGENTE"},{"situacao":"NEGOCIAÇÃO"}]}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    getTurmaColegioInicio(){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"instituicao":{"$regex":"COLÉGIO","$options":"i"},"$or":[{"situacao":"ATENDIMENTO URGENTE"},{"situacao":"NEGOCIAÇÃO"}]}&sort={"cidade":1, "instituicao":1, "curso":1,"ano":1,"periodoTurma":1,"turma":1,"sala":1,"periodo":1}');
    }

    patchTurma(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_TURMAS+'/'+id,body)
   }

   getContratoById(id:any){
      return this.http.get(this.API_URL_CONTRATOS+'/'+id);
    }

   deleteAgenda(id:any){
      return this.http.delete(this.API_URL_AGENDA+'/'+id);
     }

   patchAgenda(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_AGENDA+'/'+id,body)
   }

   getAllAgenda(){
      return this.http.get(this.API_URL_AGENDA);
    }

   postAgenda(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_AGENDA,body)
    }

   getAgendaByVendedorData(vendedor:any,start:any,end:any){
      return this.http.get(this.API_URL_AGENDA+'?filtro={"vendedor":"'+vendedor+'","start":{"$gte":"'+start+'"},"end":{"$lte":"'+end+'"},"resolvido":false}')
   }

   getAgendaByVendedor(vendedor:any){
      return this.http.get(this.API_URL_AGENDA+'?filtro={"vendedor":"'+vendedor+'"}')
   }

   getUsuarios(){
      return this.http.get(this.API_URL_USUARIOS+'?sort={"nome":1}')
   }

   getAllVendedores(){
      return this.http.get(this.API_URL_USUARIOS+'?filtro={"tipo":"Vendedor"}')
   }

   getUsuarioByEmail(key:any){
      return this.http.get(this.API_URL_USUARIOS+'?filtro={"email":"'+key+'"}')
   }

   getCidades(){
      return this.http.get(this.API_URL_CIDADES+'?sort={"nome":1}')
   }

   getOrcamentoByData(inicio:any,fim:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"data":{"$gte":"'+inicio+'","$lte":"'+fim+'"}}')
   }

   getOrcamentoByProposta(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"nProposta":"'+key+'"}')
   }

   getOrcamentoByInstituicao(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"instituicao":{"$regex":"'+key+'", "$options":"i"}}')
   }

   getOrcamentoByCurso(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"curso":{"$regex":"'+key+'", "$options":"i"}}')
   }
   
   getOrcamentoByContato(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"contatos.nome":{"$regex":"'+key+'", "$options":"i"}}')
   }
   
   getOrcamentoByConsultor(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"consultor":{"$regex":"'+key+'", "$options":"i"}}')
   }

   getOrcamentoByCidade(key:any){
      return this.http.get(this.API_URL_ORCAMENTOS+'?filtro={"cidade":"'+key+'"}')
   }

   postCidade(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_CIDADES,body)
   }

   postInstituicao(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_INSTITUICOES,body)
   }

   postCurso(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_CURSOS,body)
   }

   postTurma(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_TURMAS,body)
   }

   deleteCidade(id:any){
      return this.http.delete(this.API_URL_CIDADES+'/'+id);
     }

   deleteEmpresa(id:any){
   return this.http.delete(this.API_URL_EMPRESAS+'/'+id);
   }

   deleteInstituicao(id:any){
      return this.http.delete(this.API_URL_INSTITUICOES+'/'+id);
   }

   deleteCurso(id:any){
      return this.http.delete(this.API_URL_CURSOS+'/'+id);
   }

   deleteTurma(id:any){
      return this.http.delete(this.API_URL_TURMAS+'/'+id);
   }

   deleteDocumento(id:any){
      return this.http.delete(this.API_URL_DOCUMENTOS+'/'+id);
   }

   deleteContrato(id:any){
      return this.http.delete(this.API_URL_CONTRATOS+'/'+id);
   }

   deleteUsuario(id:any){
      return this.http.delete(this.API_URL_USUARIOS+'/'+id);
   }

   enviarDocTurma(turmaId:any,imagedata:any,random:any){
      let url = this.urlSite+'/uploadDocTurma.php?turma='+turmaId+'&random='+random;
      return this.http.post(url, imagedata);
   }

   postContrato(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_CONTRATOS,body);
   }

   postUsuario(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_USUARIOS,body);
   }

   postRelatorio(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_RELATORIOS,body);
   }

   patchOrcamento(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_ORCAMENTOS+'/'+id,body)
   }

   patchContrato(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_CONTRATOS+'/'+id,body)
   }

   patchUsuario(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_USUARIOS+'/'+id,body)
   }

   getImagensByGaleria(key:any){
      return this.http.get(this.API_URL_IMAGENS+'?filtro={"galeria":"'+key+'"}')     
   }

   getMissaByTipo(key:any){
     return this.http.get(this.API_URL_MISSA+'?filtro={"tipo":"'+key+'"}')
   }

   getColacaoByTipo(key:any){
      return this.http.get(this.API_URL_COLACAO+'?filtro={"tipo":"'+key+'"}')
    }

   getSaudadeByTipo(key:any){
      return this.http.get(this.API_URL_SAUDADE+'?filtro={"tipo":"'+key+'"}')
    }

   getJantarByTipo(key:any){
      return this.http.get(this.API_URL_JANTAR+'?filtro={"tipo":"'+key+'"}')
   }

   getBaileByTipo(key:any){
      return this.http.get(this.API_URL_BAILE+'?filtro={"tipo":"'+key+'"}')
   }

   getPreEventosByTipo(key:any){
      return this.http.get(this.API_URL_PRE_EVENTOS_INFANTIL+'?filtro={"tipo":"'+key+'"}')
    }

    getProducaoFotograficaByTipo(key:any){
      return this.http.get(this.API_URL_PROD_FOTO_INFANTIL+'?filtro={"tipo":"'+key+'"}')
    }

    getFormaturasByTipo(key:any){
      return this.http.get(this.API_URL_FORMATURA_INFANTIL+'?filtro={"tipo":"'+key+'"}')
    }

   getTurmaUnica(cidade:any,instituicao:any,curso:any,sala:any,periodo:any){
      return this.http.get(this.API_URL_TURMAS+'?filtro={"cidade":"'+cidade+'","instituicao":"'+instituicao+'","curso":"'+curso+'","sala":"'+sala+'","periodo":"'+periodo+'"}&sort={"curso":1, "ano":-1}');
   }

   getMinhaFormaturaByData(inicio:any,fim:any){
      return this.http.get(this.API_URL_MINHA_FORMATURA+'?filtro={"data":{"$gte":"'+inicio+'","$lte":"'+fim+'"}}')
   }

   getMinhaFormaturaByInstituicao(key:any){
      return this.http.get(this.API_URL_MINHA_FORMATURA+'?filtro={"instituicao":{"$regex":"'+key+'", "$options":"i"}}')
   }

   getMinhaFormaturaByCurso(key:any){
      return this.http.get(this.API_URL_MINHA_FORMATURA+'?filtro={"curso":{"$regex":"'+key+'", "$options":"i"}}')
   }
 
   getMinhaFormaturaByCidade(key:any){
      return this.http.get(this.API_URL_MINHA_FORMATURA+'?filtro={"cidade":"'+key+'"}')
   }

   getMinhaFormatura(){
      return this.http.get(this.API_URL_MINHA_FORMATURA);
   }

   getCursos(){
      return this.http.get(this.API_URL_TODOS_CURSOS);
   }

   getInstituicoes(){
      return this.http.get(this.API_URL_INSTITUICOES);
   }

   getInstituicoesFaculdade(){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"tipo":"UNIVERSIDADE"}')
   }

   getInstituicoesColegio(){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"tipo":"COLEGIO"}')
   }

   getInstituicoesInfantil(){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"tipo":"INFANTIL"}')
   }

   getInstituicoesEscola(){
      return this.http.get(this.API_URL_INSTITUICOES+'?filtro={"tipo":"ESCOLA"}')
   }

   getFormaturaById(id:any){
      return this.http.get(this.API_URL_MINHA_FORMATURA+'/'+id);
    }

   getPersonalizadosBaile(){
      return this.http.get(this.API_URL_PERSONALIZADOS_BAILE);
   }

   getPersonalizadosBaileColegio(){
      return this.http.get(this.API_URL_PERSONALIZADOS_BAILE_COLEGIO);
   }

   getFormaturaInfantil(){
      return this.http.get(this.API_URL_FORMATURA_INFANTIL);
   }

   getFormaturaInfantilById(id:any){
      return this.http.get(this.API_URL_FORMATURA_INFANTIL+'/'+id);
   }

   patchFormaturaInfantil(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_FORMATURA_INFANTIL+'/'+id,body)
   }

   postFormaturaInfantil(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_FORMATURA_INFANTIL,body);
   }

   delFormaturaInfantil(id:any){
      return this.http.delete(this.API_URL_FORMATURA_INFANTIL+'/'+id);
     }

   getProdFotoInfantil(){
      return this.http.get(this.API_URL_PROD_FOTO_INFANTIL);
   }

   getProdFotoInfantilById(id:any){
      return this.http.get(this.API_URL_PROD_FOTO_INFANTIL+'/'+id);
   }
   
   patchProdFotoInfantil(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_PROD_FOTO_INFANTIL+'/'+id,body)
   }

   postProdFotoInfantil(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_PROD_FOTO_INFANTIL,body);
   }

   delProdFotoInfantil(id:any){
      return this.http.delete(this.API_URL_PROD_FOTO_INFANTIL+'/'+id);
     }

   getPreEventosInfantil(){
      return this.http.get(this.API_URL_PRE_EVENTOS_INFANTIL);
   }

   getPreEventosInfantilById(id:any){
      return this.http.get(this.API_URL_PRE_EVENTOS_INFANTIL+'/'+id);
   }

   patchPreEventosInfantil(id:any,dados:any){
      let body = JSON.stringify(dados);
      return this.http.patch(this.API_URL_PRE_EVENTOS_INFANTIL+'/'+id,body)
   }

   postPreEventosInfantil(dados:any){
      let body = JSON.stringify(dados);
      return this.http.post(this.API_URL_PRE_EVENTOS_INFANTIL,body);
   }

   delPreEventosInfantil(id:any){
      return this.http.delete(this.API_URL_PRE_EVENTOS_INFANTIL+'/'+id);
     }
   

}